const model = {
  id: null,
  name: null,
  ids: {},
  children: [],
  transport_systems: [],
  profiles: []
};
const fill = {
  activeCp: null,
  activeCpName: null,
  detalization_type: null,
  interval_type: null,
  dates: [],
  date: undefined,
  intervals: [],
  interval: undefined,
  columns: [],
  rows: [],
  transport_systems: [],
  coefsEnabled: false,
  hoveredTurn: null,
  loading: false,
  profile: undefined,
  gcpLinkGeom: null
};

const state = {
  view: "model-list",
  mode: null,
  model,
  fill
};

const mutations = {
  SET_TC_MODEL(state, { id, name, ids, children }) {
    state.model.id = id;
    state.model.name = name;
    state.model.ids = ids;
    state.model.children = children;
  },
  CLEAR_TC_MODEL(state) {
    state.model = {
      ...model
    };
  },
  SET_TC_TRANSPORT_SYSTEMS(state, value) {
    state.model.transport_systems = value;
  },
  SET_TC_PROFILES(state, value) {
    state.model.profiles = value;
  },
  SET_TC_STATE_PROP(state, { name, value }) {
    state[name] = value;
  },
  SET_TC_FILL(state, config) {
    state.fill = {
      ...state.fill,
      ...config
    };
  },
  SET_TC_FILL_PROP(state, { name, value }) {
    state.fill[name] = value;
  },
  CLEAR_TC_FILL(state) {
    state.fill = {
      ...fill
    };
  }
};

export default { state, mutations };
